// extracted by mini-css-extract-plugin
export var editButton = "_kh-0";